import { User } from '@/domain/entities/user/user'
import { AuthRepository } from '@/domain/repositories/auth/AuthRepository'

export class LoginUseCase {
  constructor(private authRepository: AuthRepository) {}

  async login(id: string, password: string): Promise<User> {
    try {
      const data = await this.authRepository.login(id, password)
      return data
    } catch (error) {
      console.error(`Error in LoginUseCase: ${error instanceof Error ? error.message : String(error)}`)
      throw error
    }
  }
}
